import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

// 路由
export const constantRoutes = [{
    path: "/",
    redirect: "/index",
    hidden: true
  },
  {
    path: "/index",
    name: "index",
    hidden: true,
    component: () => import("@/views/index.vue")
  },
  {
    path: "/adminConsole",
    name: "adminConsole",
    hidden: true,
    component: () => import("@/views/adminConsole.vue")
  },
  {
    path: "/billingMethod",
    name: "billingMethod",
    hidden: true,
    component: () => import("@/views/billingMethod.vue")
  },
  {
    path: "/mustRead",
    name: "mustRead",
    hidden: true,
    component: () => import("@/views/mustRead.vue")
  },
  {
    path: "/notice",
    name: "notice",
    hidden: true,
    component: () => import("@/views/notice.vue")
  },
  {
    path: "/article/:articleid",
    // path: "/:articleid",
    name: "article",
    hidden: true,
    component: () => import("@/views/article.vue")
  },
  {
    path: "/addfunds",
    name: "addfunds",
    hidden: true,
    component: () => import("@/views/addfunds.vue")
  },
  {
    path: "/aisetting",
    name: "aisetting",
    hidden: true,
    component: () => import("@/views/aisetting.vue")
  },
  {
    path: "/data",
    name: "data",
    hidden: true,
    component: () => import("@/views/data.vue")
  },
  {
    path: "/push",
    name: "push",
    hidden: true,
    component: () => import("@/views/push.vue")
  },
  {
    path: "/test",
    name: "test",
    hidden: true,
    component: () => import("@/views/test.vue")
  },
  {
    path: "/webkeywords",
    name: "webkeywords",
    hidden: true,
    component: () => import("@/views/webkeywords.vue")
  },
  {
    path: "/webmanage",
    name: "webmanage",
    hidden: true,
    component: () => import("@/views/webmanage.vue")
  },
  {
    path: "/addsite",
    name: "addsite",
    hidden: true,
    component: () => import("@/views/addsite.vue")
  },
  {
    path: "/massaddtype",
    name: "massaddtype",
    hidden: true,
    component: () => import("@/views/massaddtype.vue")
  },
  {
    path: "/articleedit",
    name: "articleedit",
    hidden: true,
    component: () => import("@/views/articleedit.vue")
  },
  {
    path: "/login",
    name: "login",
    hidden: true,
    component: () => import("@/views/login.vue")
  }, {
    path: "/signup",
    name: "signup",
    hidden: true,
    component: () => import("@/views/signup.vue")
  }, {
    path: "/accountsetting",
    name: "accountsetting",
    hidden: true,
    component: () => import("@/views/accountsetting.vue")
  }, {
    path: "/reset",
    name: "reset",
    hidden: true,
    component: () => import("@/views/reset.vue")
  }, {
    path: "/verify",
    name: "verify",
    hidden: true,
    component: () => import("@/views/verify.vue")
  },{
    path: "/forgotPassword",
    name: "forgotPassword",
    hidden: true,
    component: () => import("@/views/forgotPassword.vue")
  },{
    path: "/forgotPasswordTwo",
    name: "forgotPasswordTwo",
    hidden: true,
    component: () => import("@/views/forgotPasswordTwo.vue")
  },{
    path: "/addsiteMore",
    name: "addsiteMore",
    hidden: true,
    component: () => import("@/views/addsiteMore.vue")
  },{
    path: "/userWallet",
    name: "userWallet",
    hidden: true,
    component: () => import("@/views/userWallet.vue")
  },
];
const createRouter = () =>
  new Router({
    mode: "history", // 去掉url中的#
    // mode: "hash",
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  });
let router = createRouter();

/**
 * 重写路由的push方法,防止连续点击多次路由报错
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
//全局前置守卫
router.beforeEach((to,from,next) =>{
  // console.log({to,from});
  // if(to.fullPath.includes('/article?id=')){
  //   let id = to.fullPath.split('/article?id=')[1]
  //   let path = `/article/${id}.html`
  //   router.addRoute({path,meta:{isAdd:true},component:()=>import("@/views/article.vue")})
  //   console.log(path);
  //   next({
	// 		path,
	// 		replace: true, 
	// 	})
  // }else if(from.fullPath=='/'&&to.fullPath.includes('/article/')&&!to.meta.isAdd){
  //   router.addRoute({path:to.fullPath,meta:{isAdd:true},component:()=>import("@/views/article.vue")})
  //   next({
	// 		path: to.fullPath,
	// 		replace: true,
	// 	})
  // }else{
  //   next()
  // }
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js